import React, { useState, Dispatch, useEffect } from 'react';
import { Row, Col, Button, Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import {payCash} from '../../../api/purchase';
import TextField from '../TextField';
import {mostrarError} from '../../../reducer/config-reducer'
import { connect } from 'react-redux';
import {GenericObject} from '../../../types/types';
import { fetchDetalleCompra } from '../../../reducer/events-reducer';

const TipoPagoCash = (props:{mostrarError:Dispatch<GenericObject | null>, eventType:number, fetchDetalleCompra: Dispatch<void>}) => {
    const [numeroIdentidad, setNumeroIdentidad] = useState('');
    const [medioDePago, setmedioDePago] = useState('Seleccione un medio de pago');
    const [dropdownOpenFecha, setDropdownOpenFecha] = useState(false);
    const opcionesDePago = [{ label: "Pago Fácil", value: "pagofacil" }, { label: "Rapipago", value: "rapipago" }]
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchDetalleCompra();
    }, []);

    const handleDropDownFecha = () => {
        setDropdownOpenFecha((prevState) => !prevState);
    }

    const handlePagarButton = async() => {
        const res = await payCash(numeroIdentidad, medioDePago);
        if(res.result){
            navigate(`/pago-pendiente/cash/${res.checkoutData.paymentMethod}/${res.checkoutData.additionalCode}/${props.eventType}`)
        }else{
            props.mostrarError(res)
        }
    }

    const validateInput = async (name:string, value:string,  event: React.ChangeEvent<HTMLInputElement>) => {
        let error = '';

        if (event.target.required && event.target.value.trim() === '') {
            error = 'Complete el campo';
        } else if (event.target.value.length > parseInt(event.target.getAttribute('max') || '')) {
            error = `El campo debe tener como máximo ${event.target.getAttribute('max')} caracteres`;
        }

        setError(error)

        if (error !== '') {
            event.target.classList.add('has-error');
        } else {
            event.target.classList.remove('has-error');
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setNumeroIdentidad(event.target.value)
    }
    return (
        <>
            <Row>
                <Col><h4 className='subtitle'>Completá los datos de pago</h4></Col>
            </Row>
            <Row>
                <Col className='form-data'>
                    <TextField required={true} type='number' id='numeroIdentidad' label='Ingresa aquí tu DNI' value={numeroIdentidad} errorMsg={error} handleInputChange={handleInputChange} validate={validateInput} focusEvent={() => {setError(''); setNumeroIdentidad('')}} />
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Dropdown isOpen={dropdownOpenFecha} toggle={handleDropDownFecha} direction='down'>
                        <DropdownToggle caret tag='div' className='select'>
                            <span>{medioDePago}</span>
                        </DropdownToggle>
                        <DropdownMenu tag={'ul'} className='options'>
                            {opcionesDePago.map((opcion, index) => {
                                return <li key={index} onClick={() => { setmedioDePago(opcion.value);handleDropDownFecha()  }}>{opcion.label}</li>;
                            })}
                        </DropdownMenu>
                    </Dropdown>
                </Col>
            </Row>
            <Row className='mt-3 mb-3'>
                <Col className='steps-buttons'>
                    <Button className='w-100 mb-3 bt-pagar-tipo-pago' onClick={handlePagarButton} disabled={numeroIdentidad === '' || medioDePago==='Seleccione un medio de pago'}> <strong>GENERAR COD. de PAGO</strong></Button>
                </Col>
            </Row>
        </>
    );
};

export default connect(
    null,
    { mostrarError, fetchDetalleCompra }
  )(TipoPagoCash);